















import Component from 'vue-class-component';
import Vue from 'vue';
import {Prop} from 'vue-property-decorator';
import BindAttrs from '@/utils/binds-attrs';
import AmetrasNumberFieldTemplate from '@/fields/text/AmetrasNumberFieldTemplate.vue';
import {HTTP_SERVICE_INSTANCE} from '@/services/http.service';
import {DisguiseBusinessExceptionWrapper} from '@/exception/disguise-business-exception-wrapper';

/**
 * Page size for DT
 */
@Component({
  components: {AmetrasNumberFieldTemplate},
  mixins: [BindAttrs]
})
export default class DataTablePaginationSizeConfig extends Vue {

  @Prop() paginationMode!: DisguiseDto.PaginationMode;
  @Prop() paginationSettings!: DisguiseDto.DTPaginationSettings;
  @Prop() lazySettings!: DisguiseDto.DTLazyLoadingDto;

  updatePageSize(
      newValue: number
  ) {
    if (this.paginationSettings.configurationEndpointUrl) {
      HTTP_SERVICE_INSTANCE.getAxios().post(this.paginationSettings.configurationEndpointUrl, {
        size: newValue
      } as DisguiseDto.DTPageSizeSaveDto).then(() => {
        this.$store.commit('showSnack', {
          message: this.paginationSettings.pageSizeChangedSuccessMessage,
          color: 'success'
        });
      }, (error) => {
        if (!(error instanceof DisguiseBusinessExceptionWrapper)) {
          this.$store.commit('showSnack', {
            message: this.paginationSettings.pageSizeChangedFailMessage,
            color: 'error'
          });
        }
      });
    }

    this.$emit('change', newValue);
  }

}
